import React, { useEffect, useState } from "react";
import { Instagram, X } from "lucide-react";
import { companyInfo } from "../mock";

/**
 * Floating "Follow us on Instagram" widget.
 * - Appears bottom-left after a short delay so it doesn't compete with the
 *   chat / book CTA bubbles on the right.
 * - Pulses gently to attract attention.
 * - Dismissable; respects user choice via localStorage for the session.
 */
const FollowInstagram = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("kcc_ig_dismissed") === "1") {
      setDismissed(true);
      return;
    }
    const t = setTimeout(() => setVisible(true), 1800);
    return () => clearTimeout(t);
  }, []);

  if (dismissed) return null;

  const dismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    sessionStorage.setItem("kcc_ig_dismissed", "1");
    setDismissed(true);
  };

  return (
    <a
      href={companyInfo.socials.instagram}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="follow-instagram-widget"
      aria-label="Follow Knight Credit Consultants on Instagram"
      className={`fixed left-5 bottom-24 z-40 group flex items-center gap-3 pl-3 pr-4 py-2.5
        rounded-full text-white font-semibold text-sm
        bg-gradient-to-tr from-[#f09433] via-[#dc2743] to-[#bc1888]
        shadow-2xl shadow-fuchsia-500/30 hover:shadow-fuchsia-500/50
        transition-all duration-500
        ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"}
        hover:-translate-y-1 hover:scale-[1.03]`}
    >
      {/* Pulsing dot */}
      <span className="relative flex items-center justify-center w-8 h-8 rounded-full bg-white/15 ring-1 ring-white/30">
        <span className="absolute inset-0 rounded-full bg-white/30 animate-ping" />
        <Instagram size={16} className="relative text-white" />
      </span>
      <span className="hidden sm:inline whitespace-nowrap">Follow us on Instagram {companyInfo.socials.instagramHandle}</span>
      <span className="sm:hidden whitespace-nowrap">Follow on IG {companyInfo.socials.instagramHandle}</span>
      <button
        onClick={dismiss}
        className="ml-1 w-5 h-5 rounded-full bg-white/15 hover:bg-white/30 flex items-center justify-center transition-colors"
        aria-label="Dismiss Instagram banner"
        data-testid="follow-instagram-dismiss"
      >
        <X size={11} />
      </button>
    </a>
  );
};

export default FollowInstagram;
